import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/es.ts
var add = "Añadir";
var remove = "Quitar";
var removeAll = "Quitar todos";
var incomplete = "Discúlpe, los campos no fueron completados correctamente.";
var submit = "Enviar";
var noFiles = "Archivo no seleccionado";
var moveUp = "Moverse hacia arriba";
var moveDown = "Moverse hacia abajo";
var isLoading = "Cargando...";
var loadMore = "Cargar más";
var next = "Próximo";
var prev = "Anterior";
var addAllValues = "Añadir todos los valores";
var addSelectedValues = "Añadir valores seleccionados";
var removeAllValues = "Eliminar todos los valores";
var removeSelectedValues = "Eliminar los valores seleccionados";
var chooseDate = "Elige fecha";
var changeDate = "Cambiar fecha";
var close = "Cerrar";
var open = "Abrir";
var accepted = function({
  name
}) {
  return `Acepte el ${name} por favor.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} debe ser posterior a ${date(args[0])}.`;
  }
  return `${sentence(name)} debe ser una fecha futura.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} debe contener solo caractéres alfabéticos.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} debe ser alfanumérico.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} espacios alfa solo pueden contener letras y espacios.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} debe contener caracteres alfabéticos.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} debe contener letras o números.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} debe contener letras o espacios.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} debe contener un símbolo.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} debe estar en mayúsculas.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} debe contener minúsculas.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} debe contener números.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} debe ser un símbolo.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} solo puede contener letras mayúsculas.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} solo puede contener letras minúsculas.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} debe ser anterior a ${date(args[0])}.`;
  }
  return `${sentence(name)} debe ser una fecha pasada.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `El campo no fue completado correctamente y no puede ser enviado.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} debe estar entre ${a} y ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} no coincide.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} no es una fecha válida, por favor utilice el formato ${args[0]}`;
  }
  return "El campo no fue completado correctamente y no puede ser enviado.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} debe estar entre ${date(args[0])} y ${date(args[1])}`;
};
var email = "Ingrese una dirección de correo electrónico válida por favor.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} no termina con ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} no es un valor permitido.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} debe tener al menos una letra.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} debe tener como máximo ${max2} caractéres.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} debe tener ${max2} caracteres.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} debe tener como mínimo ${min2} caractéres.`;
  }
  return `${sentence(name)} debe tener entre ${min2} y ${max2} caractéres.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} no es un valor permitido.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `No puede tener más de ${args[0]} ${name}.`;
  }
  return `${sentence(name)} debe ser menor o igual a ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "No existen formatos de archivos permitidos.";
  }
  return `${sentence(name)} debe ser del tipo: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `No puede tener menos de ${args[0]} ${name}.`;
  }
  return `${sentence(name)} debe ser de al menos ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” no es un valor permitido de ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} debe ser un número.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" o ")} se requiere estar.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} es requerido.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} debe comenzar con ${list(args)}.`;
};
var url = function() {
  return `Introduce una URL válida.`;
};
var invalidDate = "La fecha seleccionada no es válida.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var es_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, es_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=es.mjs.map